var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"wrapper"},[(_vm.roomName)?_c('MovieRoom',{attrs:{"room-name":_vm.roomName,"is-admin":_vm.isAdmin,"room-url":_vm.roomUrl}}):_c('MainMenu',{on:{"changeToPlayer":_vm.changeToPlayer}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }